var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 13.1251H10.9375V9.68762C10.9375 9.17981 10.5078 8.75012 10 8.75012H8.75C8.20312 8.75012 7.8125 9.17981 7.8125 9.68762C7.8125 10.2345 8.20312 10.6251 8.75 10.6251H9.0625V13.1251H8.4375C7.89063 13.1251 7.5 13.5548 7.5 14.0626C7.5 14.6095 7.89063 15.0001 8.4375 15.0001H11.5625C12.0703 15.0001 12.5 14.6095 12.5 14.0626C12.5 13.5548 12.0703 13.1251 11.5625 13.1251ZM10 7.50012C10.6641 7.50012 11.25 6.95325 11.25 6.25012C11.25 5.58606 10.6641 5.00012 10 5.00012C9.29688 5.00012 8.75 5.58606 8.75 6.25012C8.75 6.95325 9.29688 7.50012 10 7.50012Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.97becd72a078a1de7a835bd1d9661e94.svg";
export { ForwardRef as ReactComponent };